import { post,get } from "@/api/request"

/* 直播 */
//直播首页列表
export const liveList = params => post("live/index", params)

//直播首页热门直播及筛选
export const liveListRecommend = params => post("live/index/recommend", params)

//直播详情
export const liveDetail = params => post("live/detail", params)

//直播详情meta
export const liveDetailMeta = params => post("live/detail/meta", params)

//直播详情状态
export const liveStatus = params => post("live/status", params)

//推流端列表-我的直播
//export const mylive = params => post("live/mylive", params)

//直播商品列表
export const liveGoodsList = params => post("live/goods/list", params)

//获取直播imtoken
//export const getimtoken = params => post("live/getimtoken", params)

//直播评论列表接口
export const livecommentlist = params => post("live/comment/list", params)

//暂停直播
//export const livePause = params => post("live/pause", params)

//结束直播endLive
//export const liveEnd = params => post("live/endlive", params)

//开启直播-直播初始化
//export const liveInit = params => post("live/initLive", params)

//直播间拍品统计
export const liveAuctionStatistics = params => post("live/special/auction/statistics", params)

//直播间拍品
export const liveAuctionList = params => post("live/auction/list", params)

//直播间重拍数据
export const liveReloadList = params => post("live/auction/reload/list", params)

//我的直播列表
//export const mylive = params => post("live/mylive", params)

//直播设置收藏（提醒）
export const liveRemind = params => post("live/remind", params)

//参拍协议
export const bidAgreement = params => post("live/bid/agreement", params)

//竞拍拍品详情
export const auctionDetail = params => post("live/auction/detail", params)

//竞拍拍品详情meta
export const auctionDetailMeta = params => post("live/auction/detail/meta", params)

//竞拍拍品--出价记录
export const auctionBids = params => post("live/auction/bids", params)



//根据登录用户获取授权
export const creat2 = params => post("https://tulu-app.artron.net/zxp/imjwt/creat2", params,'true')

//直播间长链推送
export const changLian = params => post("https://artronim-push.artron.net/api/message", params,'true')
//是否是会员
export const memberinfo = params => post("https://tulu-app.artron.net/member/memberinfo", params,'true')
//判断是哪个项目
export const agentSource = params => get("https://sapi.artron.net/api/agent/source", params,'true')
//会员登录限制
export const webCheck = params => post("https://user-api.artron.net/api/device/web_check", params,'true')